import { __decorate } from "tslib";
import fetchFromCache from '@/utilities/fetchFromCache';
import { Module, VuexModule, MutationAction } from 'vuex-module-decorators';
let Features = class Features extends VuexModule {
    constructor() {
        super(...arguments);
        this.features = [];
        this.cachedVersion = 0;
    }
    async fetchFeatures() {
        const { data: features, cachedVersion } = await fetchFromCache(this, 'features', 'feature');
        return { features, cachedVersion };
    }
};
__decorate([
    MutationAction({ mutate: ['features', 'cachedVersion'] })
], Features.prototype, "fetchFeatures", null);
Features = __decorate([
    Module({ namespaced: true, name: 'features' })
], Features);
export default Features;
